import React from 'react'
import { Link } from 'react-router-dom';
import './styles/Location.css';
import { TransitionGroup } from 'react-transition-group'

import loc1 from './assets/loc_01.jpg';
import loc2 from './assets/loc_02.jpg';
import loc3 from './assets/loc_03.jpg';

function Location() {  
    return (
        <div className='locationContainer'>
            <div className='locationContentContainer'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d21443.068273820423!2d9.039978531146376!3d47.79340059766647!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479a5f7331db287d%3A0xad9c02a7367ca4ef!2sWaldjugendzeltplatz%20Lipsental%20-%20Forst%20Baden-W%C3%BCrttemberg!5e0!3m2!1sde!2sde!4v1725636999383!5m2!1sde!2sde" width="100%" height="350" style={{border:0}} allowFullScreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title='map'></iframe>                
                <div className='locationTextContainer'>
                    <h1>Location</h1>
                    <h2>Jugendzeltplatz Lipsental</h2>
                    <p>Ca. 2 km östlich des kleinen Ortes Bodman, Richtung Marienschlucht, liegt in unmittelbarer Nähe zum Bodensee der Jugendzeltplatz Lipsental. Große Waldgebiete, ausgedehnte Naturschutzgebiete, vielseitige Erholungsmöglichkeiten kennzeichnen diese herrliche Hügellandschaft. Dort führen wir bereits seit 1989 das traditionelle Zeltlager der SCHREBERJUGEND, Landesverband Südwest, durch.</p>
                    <p>Die Fahrt dorthin erfolgt mit einem Reisebus ab Korntal-Münchingen. Der Zeltlagerplatz befindet sich mitten in einem Landschaftsschutzgebiet. Geschlafen wird in Gemeinschaften von maximal 5 Kindern und Jugendlichen in Zelten mit Schlafsack und auf der Luftmatratze. Für die körperliche Hygiene sind Waschgelegenheiten vorhanden.</p>
                </div>
                <div className='pictureContainer'>
                    <TransitionGroup
                        className="imgWrapper"
                        transitionName="pic1" 
                        transitionAppear={true} 
                        transitionAppearTimeout={2000} 
                        transitionEnter={false} 
                        transitionLeave={false}>
                        <img className='locPicture' src={loc1} alt={'Bild 1'}/>
                    </TransitionGroup>
                    <TransitionGroup 
                        className="imgWrapper"
                        transitionName="pic2" 
                        transitionAppear={true}
                        transitionAppearTimeout={2300} 
                        transitionEnter={false} 
                        transitionLeave={false}>
                        <img className='locPicture' src={loc2} alt={'Bild 2'}/>
                    </TransitionGroup>
                    <TransitionGroup 
                        className="imgWrapper"
                        transitionName="pic3" 
                        transitionAppear={true} 
                        timeout={400}
                        transitionAppearTimeout={2600} 
                        transitionEnter={false} 
                        transitionLeave={false}>
                        <img className='locPicture' src={loc3} alt={'Bild 3'}/>
                    </TransitionGroup>
                </div>

            </div>
            <div className='bottomContainer'>
                    <Link to='https://deutsche-schreberjugend.de/'>
                        <p> Deutsche Schreberjugend</p>
                    </Link>
                    <Link to={'/impressum'}>
                        <p>Impressum</p>
                    </Link>
                    <Link to={'/datenschutz'}>
                        <p>Datensschutz</p>
                    </Link>
            </div>
        </div> 
    )
}

export default Location